import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

/**
 * Rights & Roles moved to /settings/org/rights with the settings rework. This
 * shim keeps the old path working — bookmarks, and any link minted before the
 * move — and forwards the `?tab=&provider=` deep link so the cross-link from the
 * integrations access section survives.
 *
 * No `isAdmin` guard here: the redirect target lives under `/settings/org`,
 * whose route redirects non-admins. Same as every other shim into /settings.
 */
export const Route = createFileRoute("/_authenticated/dashboard/admin/rights")({
	validateSearch: z.object({
		tab: z.enum(["capabilities", "tools"]).optional().catch(undefined),
		provider: z.string().optional(),
	}),
	beforeLoad: ({ search }) => {
		throw redirect({ to: "/settings/org/rights", search });
	},
});
